import { render, staticRenderFns } from "./ReminderSettingsAutomation.vue?vue&type=template&id=d3e42738&scoped=true"
import script from "./ReminderSettingsAutomation.vue?vue&type=script&lang=ts"
export * from "./ReminderSettingsAutomation.vue?vue&type=script&lang=ts"
import style0 from "./ReminderSettingsAutomation.vue?vue&type=style&index=0&id=d3e42738&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3e42738",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d3e42738')) {
      api.createRecord('d3e42738', component.options)
    } else {
      api.reload('d3e42738', component.options)
    }
    module.hot.accept("./ReminderSettingsAutomation.vue?vue&type=template&id=d3e42738&scoped=true", function () {
      api.rerender('d3e42738', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings-default/ReminderSettingsAutomation.vue"
export default component.exports